import { FaMobile, FaSms, FaWhatsapp, FaEnvelope, FaTrash } from 'react-icons/fa'
import { Box, Stack, Heading, Text, Input, Select, Button, Alert, SimpleTable, Icon, Checkbox } from '@/components/lib'
import utils from '@/utils/utils'
import useStore from '@/store'

export default function Reminders ({ stage, reminders, setReminders }) {
  const { team } = useStore()
  const hasSms = utils.hasFeature(team, 'sms')
  const hasWhatsapp = utils.hasFeature(team, 'whatsapp')
  function addReminder () {
    let newReminders = Object.assign([], reminders)
    let hourToAdd = 8
    const existingHours = newReminders.map(r => r.hour)
    for (let i = 9; i < 23; i++) {
      if (existingHours.indexOf(i) === -1) {
        hourToAdd = i
        break
      }
    }
    newReminders.push({ hour: hourToAdd, title: stage?.name || 'Trialflare reminder', body: 'Please remember to submit data today.', sendVia: ['push'] })
    newReminders = newReminders.sort((a, b) => a.hour >= b.hour)
    setReminders(newReminders)
  }
  function removeReminder (hour) {
    const newReminders = Object.assign([], reminders)
    const hourToRemove = parseInt(hour)
    setReminders(newReminders.filter(r => r.hour !== hourToRemove))
  }
  function updateReminder (index, update) {
    let newReminders = Object.assign([], reminders)
    if (update.hour) {
      update.hour = parseInt(update.hour)
      const existingHours = newReminders.map(r => r.hour)
      if (existingHours.indexOf(update.hour) > -1) {
        return window.alert('You can\'t send two reminders in the same hour.')
      }
    }
    const reminder = Object.assign({}, newReminders[index], update)
    newReminders[index] = reminder
    newReminders = newReminders.sort((a, b) => a.hour >= b.hour)
    setReminders(newReminders)
  }
  function toggleSendVia (index, key) {
    const reminder = Object.assign({}, reminders[index])
    let sendVia = reminder?.sendVia || []
    if (sendVia.includes(key)) sendVia = sendVia.filter(v => v !== key)
    else sendVia.push(key)
    updateReminder(index, { sendVia })
  }

  const whatsappInUse = reminders?.some(r => r.sendVia?.includes('whatsapp'))
  const pushInUse = reminders?.some(r => r.sendVia?.includes('push'))

  return (
    <Stack gap={5} p={3} borderWidth='1px' rounded='md' bg='bg.subtle'>
      <Box>
        <Heading as='h3' size='md'>Reminders</Heading>
        <Text color='fg.muted'>Send push notifications to participants to remind them to complete this stage.</Text>
      </Box>

      <Text>Trialflare will try to send a push notification to participants for each day this stage is valid at the following hours:</Text>
      {reminders?.length > 0
        ? (
          <SimpleTable
            shadow='md'
            headers={[
              "Send at (participant's local time)",
              <Icon key='push' as={FaMobile} />,
              ...(hasSms ? [<Icon key='sms' as={FaSms} />] : []),
              ...(hasWhatsapp ? [<Icon key='whatsapp' as={FaWhatsapp} />] : []),
              <Icon key='email' as={FaEnvelope} />,
              'Reminder title',
              'Reminder body',
              ''
            ]}
            rows={reminders.map((reminder, i) => {
              const commonCells = [
                <Text key={`time-${reminder.hour}`}>
                  <Select
                    size='sm'
                    bg='bg.surface'
                    w='150px' placeholder='Pick an hour...' value={reminder.hour ?? ''}
                    onChange={e => updateReminder(i, { hour: e.target.value })}
                  >
                    {Array.from({ length: 24 }, (_, i) => i).map(hour =>
                      <option key={hour} value={hour}>{hour < 10 && '0'}{hour}:00</option>
                    )}
                  </Select>
                </Text>,
                <Text key={`push-${reminder.hour}`}><Checkbox bg='bg.surface' isChecked={reminder.sendVia?.includes('push')} onChange={e => toggleSendVia(i, 'push')} /></Text>
              ]
              const smsCell = hasSms
                ? [<Text key={`sms-${reminder.hour}`}><Checkbox bg='bg.surface' isChecked={reminder.sendVia?.includes('sms')} onChange={e => toggleSendVia(i, 'sms')} /></Text>]
                : []
              const whatsappCell = hasWhatsapp
                ? [<Text key={`whatsapp-${reminder.hour}`}><Checkbox bg='bg.surface' isChecked={reminder.sendVia?.includes('whatsapp')} onChange={e => toggleSendVia(i, 'whatsapp')} /></Text>]
                : []
              const tailCells = [
                <Text key={`email-${reminder.hour}`}><Checkbox bg='bg.surface' isChecked={reminder.sendVia?.includes('email')} onChange={e => toggleSendVia(i, 'email')} /></Text>,
                <Text key={`title-${reminder.hour}`}><Input size='sm' bg='bg.surface' value={reminder.title ?? ''} onChange={e => updateReminder(i, { title: e.target.value })} placeholder='Notification title' /></Text>,
                <Text key={`body-${reminder.hour}`}><Input size='sm' bg='bg.surface' value={reminder.body ?? ''} onChange={e => updateReminder(i, { body: e.target.value })} placeholder='Notification body' /></Text>,
                <Text key={`remove-${reminder.hour}`}><Button size='xs' onClick={e => removeReminder(reminder.hour)} variant='ghost'><Icon><FaTrash /></Icon></Button></Text>
              ]
              return [...commonCells, ...smsCell, ...whatsappCell, ...tailCells]
            })}
          />)
        : <Text color='fg.muted' fontSize='sm'>No reminders have been set yet.</Text>}

      {whatsappInUse && (
        <Alert status='info' withIcon>
          <Text>Due to WhatsApp restrictions, your configured title and body will not be sent. Instead, a generic reminder is sent via WhatsApp.</Text>
        </Alert>)}
      {pushInUse && (
        <Alert status='info' withIcon>
          Push reminders can only be sent to participants that have enabled push notifications on their device.
        </Alert>)}
      <Box>
        <Button onClick={addReminder}>Add a reminder</Button>
      </Box>
    </Stack>
  )
}
